module.exports = __webpack_public_path__ + "static/media/icons8-png.f92f288f.svg";